<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">
    <div class="card SmallForm rounded">
      <div class="card-body MyCardBody rounded-bottom text-center">
        <p>{{ 'YOU_ARE_NOT_AUTHORIZED_TO_ACCESS_THIS_PAGE' | translate }}</p>
      </div>
    </div>
  </div>
</div>
 